import { render, staticRenderFns } from "./skp.vue?vue&type=template&id=9380ec20&scoped=true"
import script from "./skp.vue?vue&type=script&lang=js"
export * from "./skp.vue?vue&type=script&lang=js"
import style0 from "./skp.vue?vue&type=style&index=0&id=9380ec20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9380ec20",
  null
  
)

export default component.exports